import { applyMiddleware, createStore } from "redux";
import rootReducer from "./rootreducer";
import logger from "redux-logger";
import thunk from "redux-thunk";

const middlewares = [logger, thunk];

const store = createStore(rootReducer, applyMiddleware(...middlewares));

export default store;
